module.exports = __webpack_public_path__ + "img/my_build_edit_empty.4ba6ae1d.jpg";